import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "./context/CartContext";
import { MenuProvider } from "./context/MenuContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import FloatingCallButton from "./components/FloatingCallButton";
import CartDrawer from "./components/CartDrawer";
import Home from "./pages/Home";
import Menu from "./pages/Menu";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Order from "./pages/Order";
import OrderSuccess from "./pages/OrderSuccess";
import Feasts from "./pages/Feasts";
import SeoLanding from "./components/SeoLanding";
import { SEO_LANDINGS } from "./seo/landingConfigs";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";
import AdminMenu from "./pages/AdminMenu";
import AdminHome from "./pages/AdminHome";
import AdminPrint from "./pages/AdminPrint";
import ScrollToTop from "./components/ScrollToTop";

function Shell() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <>
      {!isAdmin && <Header />}
      <ScrollToTop />
      <main className={isAdmin ? "" : "pt-24 md:pt-28"} data-testid="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/order" element={<Order />} />
          <Route path="/order/success" element={<OrderSuccess />} />
          <Route path="/feasts" element={<Feasts />} />
          <Route path="/feasts/:slug" element={<Feasts />} />
          {Object.values(SEO_LANDINGS).map((cfg) => (
            <Route
              key={cfg.slug}
              path={cfg.path}
              element={<SeoLanding config={cfg} />}
            />
          ))}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/menu" element={<AdminMenu />} />
          <Route path="/admin/home" element={<AdminHome />} />
          <Route path="/admin/print" element={<AdminPrint />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && <FloatingCallButton />}
      {!isAdmin && <CartDrawer />}
    </>
  );
}

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <MenuProvider>
          <CartProvider>
            <Shell />
            <Toaster position="top-center" richColors />
          </CartProvider>
        </MenuProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
